import { render } from "./FieldTable.vue?vue&type=template&id=fa92d6f4&scoped=true"
import script from "./FieldTable.vue?vue&type=script&lang=js"
export * from "./FieldTable.vue?vue&type=script&lang=js"

import "./FieldTable.vue?vue&type=style&index=0&id=fa92d6f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa92d6f4"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
